__turbopack_context__.v({
  "actionIcons": "styles-module__RL5_Pq__actionIcons",
  "categoriesDrawerButton": "styles-module__RL5_Pq__categoriesDrawerButton",
  "header": "styles-module__RL5_Pq__header",
});
